import { AxiosResponse } from "axios";

import {
  IAdminAlert,
  IAdminAlertHistoryEntry,
} from "../../@types/admin/AdminAlert";
import { api } from "../api";

/**
 * Alerts admin page (EN-5165), migrated from the Retool Alerts app
 * (`moduleAlerts`). Both of Retool's queries hit the pMp DB directly; they
 * are ported into these two endpoints so Retool and the portal read the same
 * rows during the transition.
 */
export const alertsService = {
  /**
   * Configured alerts. Omit `patientId` for the whole set — the Alerts page
   * sends nothing, the embedded per-patient panel sends an ID (Retool's
   * `patientId` module prop).
   *
   * The per-patient case goes to its own route (EN-5170) rather than the
   * filter: the page-wide list requires `alerts:access`, and the Patients
   * page's `patients:access` grant must reach one patient's alerts without
   * also opening an unfiltered read of every configured alert in the region.
   */
  async getAlerts(patientId?: number): Promise<AxiosResponse<IAdminAlert[]>> {
    if (patientId !== undefined) {
      return api.get<IAdminAlert[]>(`/Retool/Alerts/Patients/${patientId}`);
    }
    return api.get<IAdminAlert[]>("/Retool/Alerts");
  },

  /** One alert's recorded changes, newest first. */
  async getAlertHistory(
    alertId: number
  ): Promise<AxiosResponse<IAdminAlertHistoryEntry[]>> {
    return api.get<IAdminAlertHistoryEntry[]>(
      `/Retool/Alerts/${alertId}/History`
    );
  },
};
